import { GET_CLIENTS_AVAILABILITY } from '../../constants';

const initialState = {
  data: [],
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case GET_CLIENTS_AVAILABILITY.LOAD:
      return {
        ...state,
        loading: true,
      };
    case GET_CLIENTS_AVAILABILITY.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case GET_CLIENTS_AVAILABILITY.FAIL:
      return {
        ...state,
        error: payload,
        loading: true,
      };
    default:
      return state;
  }
}
